/** The pocket's search field (mockup .p-search): a search icon in a 34px field; Esc clears the text before it closes anything. */
import { Icons, TextInput } from "@/components/ui";
export function MemorySearchField({
  value,
  onChange,
  placeholder,
  testId,
  autoFocus = false,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  testId: string;
  autoFocus?: boolean;
}) {
  return (
    <div className="relative mb-2">
      <Icons.Search
        className="pointer-events-none absolute left-2.5 top-2.5 h-3.5 w-3.5 text-muted"
        aria-hidden="true"
      />
      <TextInput
        type="search"
        value={value}
        placeholder={placeholder}
        aria-label={placeholder}
        autoFocus={autoFocus}
        className="h-[34px] pl-[30px]"
        data-testid={testId}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Escape" && value) {
            event.stopPropagation();
            onChange("");
          }
        }}
      />
    </div>
  );
}
